import { render } from "./ProductModel.vue?vue&type=template&id=6817098e&scoped=true"
import script from "./ProductModel.vue?vue&type=script&lang=js"
export * from "./ProductModel.vue?vue&type=script&lang=js"

import "./ProductModel.vue?vue&type=style&index=0&id=6817098e&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6817098e"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
